import script from "./HotSpotListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HotSpotListItem.vue?vue&type=script&setup=true&lang=js"

import "./HotSpotListItem.vue?vue&type=style&index=0&id=1adf3115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adf3115"]])

export default __exports__